import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PlantListCompanyState } from './plant-list-company.models';

export const selectPlantListCompanyState = createFeatureSelector<PlantListCompanyState>('plantListCompany');

export const selectPlantListByKey = (userGuid: string, companyGuid: string) =>
  createSelector(selectPlantListCompanyState, (state) => state.plants[`${userGuid}_${companyGuid}`] || null);

export const selectPlantListCompanyLoading = createSelector(selectPlantListCompanyState, (state) => state.loading);

export const selectPlantListCompanyError = createSelector(selectPlantListCompanyState, (state) => state.error);
